import { getProtected, postProtected } from './utils';

export var setFavorite = function setFavorite(playerSessionID, gameId) {
  var tableId = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  var setLinkedGames = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;

  return postProtected('/casino/set-favorite/' + gameId + '?setLinkedGames=' + setLinkedGames + (tableId ? '&tableId=' + tableId : ''), playerSessionID);
};

export var removeFavorite = function removeFavorite(playerSessionID, gameId) {
  var tableId = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  var removeLinkedGames = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;

  return postProtected('/casino/remove-favorite/' + gameId + '?removeLinkedGames=' + removeLinkedGames + (tableId ? '&tableId=' + tableId : ''), playerSessionID);
};

export var getFavorites = function getFavorites(playerSessionID) {
  return getProtected('/casino/favorites', playerSessionID);
};

export var setLastPlayedGame = function setLastPlayedGame(playerSessionID, gameId, tableId) {
  var setLinkedGames = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
  return postProtected('/casino/set-last-played-game?gameId=' + gameId + '&setLinkedGames=' + setLinkedGames + (tableId ? '&tableId=' + tableId : ''), playerSessionID);
};

export var getLastPlayedGames = function getLastPlayedGames(playerSessionID, platform) {
  return getProtected('/casino/last-played-games' + (platform ? '?platform=' + platform : ''), playerSessionID);
};

export default {
  setFavorite: setFavorite,
  removeFavorite: removeFavorite,
  getFavorites: getFavorites,
  setLastPlayedGame: setLastPlayedGame,
  getLastPlayedGames: getLastPlayedGames
};